import React from "react";
import { DaySummary } from "components/CheckInCheckOut/types";

import workLogo from "assets/images/work-logo.svg";
import breakLogo from "assets/images/break-logo.svg";
import nursingLogo from "assets/images/nursing-logo.svg";

import "./DaySummaryCard.scss";

interface DaySummaryCardProps {
  daySummary: DaySummary;
  title?: string;
  employeeName?: string;
  date?: string;
}

function DaySummaryCard({ daySummary, title, employeeName, date }: DaySummaryCardProps) {
  const safeDaySummary = {
    totalHours: daySummary?.totalHours || "0 hr 0 min",
    timeWorked: daySummary?.timeWorked || "0 hr 0 min",
    breaks: daySummary?.breaks || "0 hr 0 min",
    nursing: daySummary?.nursing || "0 min",
  };

  return (
    <div className="day-summary-box p-05">
      {title && <p className="heading-h4-medium color-text-heading-primary mt-05 mb-05">{title}</p>}

      {employeeName && (
        <div className="mb-05">
          <p className="para-body-m-regular secondary-text-color">{employeeName}</p>
          {date && <p className="heading-h5-medium color-text-heading-primary">{date}</p>}
        </div>
      )}

      <div className="flex justify-between day-summary-divider">
        <p className="heading-h5-regular secondary-text-color">Total clocked in hours</p>
        <p className="heading-h5-medium color-text-headings-primary text-right">{safeDaySummary.totalHours}</p>
      </div>

      <div className="divider-color divider" />
      <div className="divider" />

      <div>
        {safeDaySummary.timeWorked && (
          <div className="flex justify-between align-center pt-05 pb-05">
            <div className="day-summary-icon-wrapper">
              <img src={workLogo} alt="Time worked" className="day-summary-icon" />
              <p className="para-body-m-regular secondary-text-color">Time worked</p>
            </div>
            <p className="heading-h5-medium color-text-heading-primary text-right">{safeDaySummary.timeWorked}</p>
          </div>
        )}

        {safeDaySummary.breaks && (
          <div className="flex justify-between align-center pt-05 pb-05">
            <div className="day-summary-icon-wrapper">
              <img src={breakLogo} alt="Breaks" className="day-summary-icon" />
              <p className="para-body-m-regular secondary-text-color">Time spent on breaks</p>
            </div>
            <p className="heading-h5-medium color-text-heading-primary text-right">{safeDaySummary.breaks}</p>
          </div>
        )}

        {safeDaySummary.nursing && (
          <div className="flex justify-between align-center pt-05 pb-05">
            <div className="day-summary-icon-wrapper">
              <img src={nursingLogo} alt="Nursing" className="day-summary-icon" />
              <p className="para-body-m-regular secondary-text-color">Time spent on nursing</p>
            </div>
            <p className="heading-h5-medium color-text-heading-primary text-right">{safeDaySummary.nursing}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default DaySummaryCard;
